import { ReactNode, memo } from 'react';
import { Responsive, WidthProvider } from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

const ResponsiveGridLayout = WidthProvider(Responsive);

interface ResponsiveGridLayoutComponentPropsType {
  cols?: any;
  breakpoints?: any;
  className?: string;
  isResizable?: boolean;
  isDraggable?: boolean;
  children?: ReactNode;
  margin?: [number, number];
}

export const ResponsiveGridLayoutComponent = memo(
  ({
    children,
    margin = [20, 20],
    className = 'layout bg-light',
    isResizable = false,
    isDraggable = false,
    cols = { lg: 12, md: 12, sm: 12, xs: 12, xxs: 12 },
    breakpoints = { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
  }: ResponsiveGridLayoutComponentPropsType) => {
    return (
      <ResponsiveGridLayout
        cols={cols}
        margin={margin}
        className={className}
        breakpoints={breakpoints}
        isResizable={isResizable}
        isDraggable={isDraggable}
        draggableCancel=".draggableCancelSwitch"
      >
        {children}
      </ResponsiveGridLayout>
    );
  },
);
